<div class="container-fluid">
    <app-report reportId="purchaseDashboard" screen="DASHBOARDNEW"></app-report>
  </div>
